import { Pipe, PipeTransform, inject } from '@angular/core';
import { CompaniesService } from './companies.service';

@Pipe({
  name: 'companyName',
  standalone: true
})
export class CompaniesPipe implements PipeTransform {

  private companyService = inject(CompaniesService)

  transform(code: string): string {
    console.log('CompaniesPipe', 'transform', code)

    return this.companyService.translateName(code);
  }

}
